import { render } from "./faq-footer.vue?vue&type=template&id=ecbb09c6&scoped=true"
import script from "./faq-footer.vue?vue&type=script&lang=js"
export * from "./faq-footer.vue?vue&type=script&lang=js"

import "./faq-footer.vue?vue&type=style&index=0&id=ecbb09c6&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecbb09c6"]])

export default __exports__